import React from "react";
import SelectReact from 'react-select'

export default function Select(props) {
  const { form, field } = props;
  const selected = props.options.find((item) => String(item.value) === String(field.value)) || null;
  const onChangeHandler = (item) => {
    if(!item)
    {
      form.setFieldValue(field.name, null);
    if (props.alsoOnchange) {
      props.alsoOnchange(null);
    }
    return;
    }
    form.setFieldValue(field.name, item.value);
    if (props.alsoOnchange) {
      props.alsoOnchange(item.value);
    }
  };


  return (
    <div
      className="text-sx col-span-2 mt-4"
      style={{ zIndex: 99, position: "relative" }}
    >
       <label
        className="block uppercase text-blueGray-600 dark:text-white text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {props.label}
      </label>
     <SelectReact placeholder="انتخاب..." value={selected} onChange={onChangeHandler} options={props.options}

         menuPortalTarget={document.body}
         //clearValue={onClearHandler}
         styles={{ menuPortal: base => ({ ...base, zIndex: 9999,color:'black' }) }} isClearable/>
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
}
